'use strict';

angular.module('userRequestEditControllers')

.controller('UserRequestSideBarController', ['$scope', '$state', 'systemTypes', 'businessProcesses', 'userRequest', 'existingSysRoles', function ($scope, $state, systemTypes, businessProcesses, userRequest, existingSysRoles) {

    $scope.startCollapsed = true;
    $scope.businessProcesses = businessProcesses;
    $scope.sidebarSystemTypes = systemTypes;

    $scope.catalogs = {};
    $scope.catalogs.bySystem = true;
    $scope.catalogs.byBusinessTask = false;

    // Compute nb system roles
    var countForPendings = _.countBy(userRequest.SystemRolePendings, 'SystemTypeID');

    var countForExistings = _.chain(existingSysRoles)
                             .filter(function (existingSysRole) {
                                 return _.findIndex(userRequest.SystemRolePendings, { SystemRoleID: existingSysRole.SystemRoleID }) === -1;
                             })
                             .countBy('SystemTypeID')
                             .value();

    var nbSystemRoles = function (systemType) {
        var total = 0;

        if (countForPendings.hasOwnProperty(systemType.SystemTypeID)) {
            total += countForPendings[systemType.SystemTypeID];
        }

        if (countForExistings.hasOwnProperty(systemType.SystemTypeID)) {
            total += countForExistings[systemType.SystemTypeID];
        }

        return total;
    }

    _.map($scope.sidebarSystemTypes, function (systemType) {
        systemType.nbSystemRoles = nbSystemRoles(systemType);
    });

    // By System Type
    $scope.goBySystemCatalog = function () {
        $scope.goToEditSystemType($scope.firstSystemType, {});
    }

    // Display Location Equipment
    $scope.goToLocationEquipment = function () {
        $state.go('userAccessRequest.edit.locationEquipment');
    }

    // By Business Task   
    $scope.goByBusinessTaskCatalog = function () {
        $state.go('userAccessRequest.edit.taskcatalog');
    }
}]);